import axios from "../api/axios";
import {CREATE_ORDER_URL} from "../utils/constants";

export async function createOrder(data: any): Promise<any> {
    const response = await axios.post(CREATE_ORDER_URL, data);
    return response.data;
}
